module.exports = __webpack_public_path__ + "img/ils-logo-128x144.2acea26f.png";